<template>
  <div>
    <el-card class="margin-top-sm">
      <div slot="header" class="flex justify-between">
        <div>{{ $t('mallUser.queryCondition') }}</div>
      </div>
      <div class="">
        <el-form :inline="true" :model="mallUserInfo.conditions" class="flex justify-start">
          <el-form-item>
            <el-form-item>
              <el-input v-model="mallUserInfo.conditions.nameLike" :placeholder="$t('mallUser.namePlaceholder')"
                clearable />
            </el-form-item>
          </el-form-item>
          <el-form-item>
            <el-form-item>
              <el-input v-model="mallUserInfo.conditions.tel" :placeholder="$t('mallUser.telPlaceholder')" clearable />
            </el-form-item>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" @click="_queryMallUserMethod">
              {{ $t('mallUser.query') }}
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <el-card class="margin-top-sm">
      <div slot="header" class="flex justify-between">
        <div>{{ $t('mallUser.title') }}</div>
      </div>
      <div class="">
        <el-table :data="mallUserInfo.mallUsers" border style="width: 100%">
          <el-table-column prop="userId" :label="$t('mallUser.userId')" align="center" />
          <el-table-column prop="name" :label="$t('mallUser.name')" align="center" />
          <el-table-column prop="email" :label="$t('mallUser.email')" align="center">
            <template #default="{ row }">
              {{ row.email || '-' }}
            </template>
          </el-table-column>
          <el-table-column prop="address" :label="$t('mallUser.address')" align="center">
            <template #default="{ row }">
              {{ row.address || '-' }}
            </template>
          </el-table-column>
          <el-table-column prop="tel" :label="$t('mallUser.tel')" align="center" />
          <el-table-column prop="createTime" :label="$t('mallUser.createTime')" align="center" />
          <el-table-column :label="$t('common.operation')" align="center" width="220">
            <template #default="{ row }">
              <el-button-group>
                <el-button size="mini" @click="_openDeleteMallUserModel(row)">
                  {{ $t('common.delete') }}
                </el-button>
                <el-button size="mini" @click="_openResetMallUserPwdModel(row)">
                  {{ $t('common.resetPwd') }}
                </el-button>
                <el-button size="mini" @click="_toUserDetail(row)">
                  {{ $t('common.detail') }}
                </el-button>
              </el-button-group>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination @current-change="handleCurrentChange" :current-page="mallUserInfo.conditions.page"
          :page-size="mallUserInfo.conditions.row" layout="total, prev, pager, next" :total="mallUserInfo.total" />
      </div>
    </el-card>

    <delete-mall-user ref="deleteMallUser" @refresh="queryMallUser" />
    <reset-mall-user-pwd ref="resetMallUserPwd" />
  </div>
</template>

<script>
import { getMallUser } from '@/api/user/mallUserApi'
import DeleteMallUser from '@/components/user/deleteMallUser/deleteMallUser.vue'
import ResetMallUserPwd from '@/components/user/resetMallUserPwd/resetMallUserPwd.vue'

export default {
  name: 'MallUser',
  components: {
    DeleteMallUser,
    ResetMallUserPwd
  },
  data() {
    return {
      mallUserInfo: {
        mallUsers: [],
        total: 0,
        records: 1,
        conditions: {
          nameLike: '',
          tel: '',
          page: 1,
          row: 20
        }
      }
    }
  },
  created() {
    this.queryMallUser()
  },
  methods: {
    queryMallUser() {
      this._listMallUser(1, 10)
    },
    async _listMallUser(page = 1, rows = 20) {
      this.mallUserInfo.conditions.page = page
      this.mallUserInfo.conditions.row = rows
      try {
        const res = await getMallUser(this.mallUserInfo.conditions)
        this.mallUserInfo.mallUsers = res.data
        this.mallUserInfo.total = res.total
        this.mallUserInfo.records = res.records
      } catch (error) {
        console.error('获取用户列表失败:', error)
      }
    },
    _openDeleteMallUserModel(user) {
      this.$refs.deleteMallUser.open(user)
    },
    _openResetMallUserPwdModel(user) {
      this.$refs.resetMallUserPwd.open(user)
    },
    _queryMallUserMethod() {
      this._listMallUser()
    },
    _toUserDetail(user) {
      window.open(`/#/pages/user/mallUserDetail?userId=${user.userId}`)
    },
    handleCurrentChange(val) {
      this._listMallUser(val, this.mallUserInfo.conditions.row)
    }
  }
}
</script>

<style scoped>
.ibox {
  margin-bottom: 20px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 1px 1px rgba(0, 0, 0, .05);
}

.ibox-title {
  border-bottom: 1px solid #e7eaec;
  padding: 15px 15px 7px;
  min-height: 48px;
}

.ibox-content {
  padding: 15px 20px 20px;
}
</style>